import React from "react";
import { ImageProvider } from "../../../utils/image-provider";
import { Link } from "gatsby";
import "../home.css";

const HoiApp = ({ data }) => {
  const {
    app_logo,
    app_screenshot,
    app_store_button,
    bg_color,
    description,
    description_color,
    google_play_button,
    subtitle,
    subtitle_color,
    title,
    title_color,
    play_store_link,
    apple_store_link,
  } = data || {};

  return (
    <div
      className="relative w-full lg:h-full h-[150vw] pl-[6%] hoi-app-sec"
      // style={{ backgroundColor: bg_color }}
    >
      {/* Background Image Desktop*/}
      <div className="hidden lg:block absolute inset-0 -z-10">
        {/* <ImageProvider
          image={app_screenshot}
          tailwindStyle="w-full h-full object-cover"
        /> */}
        {/* <img src={app_screenshot?.url} className="w-full h-full object-fit" /> */}

        <ImageProvider
          Image={app_screenshot}
          tailwindStyle={"w-full h-full object-fit"}
          sizes="(max-width: 768px) 100vw, 1335px"
        />
      </div>

      {/* Background Image Mobile*/}
      <div className="lg:hidden block absolute inset-0 -z-10">
        {/* <ImageProvider
          image={app_screenshot}
          tailwindStyle="w-full h-full object-cover"
        /> */}
        {/* <img src={app_logo?.url} className="w-full h-full object-fit" /> */}

        <ImageProvider
          Image={app_logo}
          tailwindStyle={"w-full h-full object-fit"}
        />
      </div>

      {/* Text Section */}
      <div className="relative z-10 w-full xl:w-[50%]  flex flex-col items-start xl:items-start justify-center gap-[4vw] xl:gap-[3vh] lg:py-[3vw] md:py-[5vw] py-[7vw] text-left hoi-app-text-left">
        {/* Title */}
        <h1
          className="font-bold leading-tight text-[4.2vh]"
          style={{
            color: title_color,
          }}
        >
          <span className="xl:hidden">{title}</span>
          <span className="hidden xl:inline text-[9vh] md:text-[4vw]">
            {title}
          </span>
        </h1>
        {/* Subtitle */}
        <p
          className="leading-snug text-[2.7vh]"
          style={{
            color: subtitle_color,
          }}
        >
          <span className="xl:hidden">{subtitle}</span>
          <span className="hidden xl:inline text-[4vh]">{subtitle}</span>
        </p>
        {/* Description */}
        <p
          className="leading-snug text-[2.3vh]"
          style={{
            color: description_color,
          }}
        >
          <span className="xl:hidden">{description?.data?.description}</span>
          <span className="hidden xl:inline text-[4vh]">
            {description?.data?.description}
          </span>
        </p>
        {/* App Store Buttons */}
        <div className="flex gap-4 mt-[1.5vh] xl:mt-[2vh]">
          <Link
            to={play_store_link}
            aria-label="Download Delhi Airport app from Google Play Store"
            target="_blank"
            rel="noopener noreferrer"
            className="focus:outline focus:outline-2 focus:outline-white focus:outline-offset-4 rounded-md"
          >
            <div className="w-[30vw] xl:w-[10vw] h-[9vw] xl:h-[3vw]">
              <ImageProvider
                Image={google_play_button}
                alt="Google Play Store icon"
                tailwindStyle="w-full h-full rounded-md"
              />
            </div>
          </Link>

          <Link
            to={apple_store_link}
            aria-label="Download Delhi Airport app from the Apple App Store"
            target="_blank"
            rel="noopener noreferrer"
            className="focus:outline focus:outline-2 focus:outline-white focus:outline-offset-4 rounded-md"
          >
            <div className="w-[30vw] xl:w-[10vw] h-[9vw] xl:h-[3vw]">
              <ImageProvider
                Image={app_store_button}
                alt="Apple App Store icon"
                tailwindStyle="w-full h-full rounded-md"
              />
            </div>
          </Link>
        </div>
      </div>
      {/* Image Section */}
      {/* <div className="w-full xl:w-2/5 flex items-end justify-center xl:justify-end relative mt-auto hoi-app-img-sec">
        <ImageProvider
          Image={app_logo}
          alt={app_logo?.alternativeText || "Delhi Airport app logo"}
          tailwindStyle="hidden xl:block w-[20vw] xl:w-[8vw] xl:mb-[4vh] h-auto !object-contain"
        />
        <div className="w-full h-full flex items-end justify-center xl:justify-end xl:items-end">
          <ImageProvider
            Image={app_screenshot}
            alt={app_screenshot?.alternativeText || "Delhi Airport app screenshot"}
            tailwindStyle="w-[60vw] xl:w-[25vw] h-auto xl:h-[55vh] object-contain rounded-t-[7vh] xl:rounded-t-[7vh] hoi-app-screenshot"
          />
        </div>
      </div> */}
    </div>
  );
};

export default HoiApp;
